import {PasswordEye} from "./PasswordEye";

addEventListener('DOMContentLoaded', (event) => {
    new PasswordEye().init();
});